var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-col justify-center items-center py-6 lg:py-12" },
    [
      _c("div", [
        _vm._v("© 2021 - " + _vm._s(_vm.curYear) + " 轻熵科技 版权所有"),
      ]),
      _c(
        "div",
        [
          _c(
            "a-button",
            {
              attrs: {
                type: "link",
                href: "https://beian.miit.gov.cn/",
                target: "_blank",
              },
            },
            [_vm._v("蜀ICP备2022002998号-1")]
          ),
          _vm._v("成都轻熵科技有限责任公司"),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }